/*
* Copyright (C) Regione Lombardia
*/
export const CoreI18nConfigs = {
    messages: {
        dialogError: 'Errore',
        dialogInfo: 'Informazioni dal sistema',
        dialogSuccess: 'Operazione effettuata',
        dialogWarning: 'Attenzione',
        genericSuccess: 'Operazione completata con successo.',
        genericError: 'Errore imprevisto durante l\'invocazione del servizio.',
        fieldRequired: 'Tutti i campi contrassegnati con l\'asterisco sono obbligatori.',
        validCup: 'Cup valido'
    },
    datepickerLanguages: {
        it: {
            weekdays: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
            monthsFull: [
                'Gennaio', 'Febbraio', 'Marzo', 'Aprile',
                'Maggio', 'Giugno', 'Luglio', 'Agosto',
                'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
            ],
            monthsShort: [
                'Gen', 'Feb', 'Mar', 'Apr',
                'Mag', 'Giu', 'Lug', 'Ago',
                'Set', 'Ott', 'Nov', 'Dic',
            ],
            weekLabel: 'sett'
        },
    },
}
